import { DeliveryStatus } from 'commons'

export const deliveryStatusClassFromStatus = (status: DeliveryStatus) => {
  switch (status) {
    case DeliveryStatus.ABIERTO:
      return 'delivery-status-opened'
    case DeliveryStatus.RECIBIDO:
      return 'delivery-status-received'
    case DeliveryStatus.RECHAZADO:
      return 'delivery-status-rejected'
    case DeliveryStatus.INEXISTENTE:
      return 'delivery-status-nonexistent'
    case DeliveryStatus.SPAM:
      return 'delivery-status-spam'
    case DeliveryStatus.SUPRIMIDO:
      return 'delivery-status-suppressed'
    case DeliveryStatus.BOUNCE:
      return 'delivery-status-bounced'
    default:
      return 'delivery-status-default'
  }
}
